export default __webpack_public_path__ + "a930da8ffed45da46bf0c545a19defa9.svg";